import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _46920ce4 = () => interopDefault(import('../pages/coins/index.vue' /* webpackChunkName: "pages/coins/index" */))
const _65851fae = () => interopDefault(import('../pages/contact.vue' /* webpackChunkName: "pages/contact" */))
const _06a85452 = () => interopDefault(import('../pages/fee/index.vue' /* webpackChunkName: "pages/fee/index" */))
const _73ff5b1d = () => interopDefault(import('../pages/news/index.vue' /* webpackChunkName: "pages/news/index" */))
const _3f4147e7 = () => interopDefault(import('../pages/referral/index.vue' /* webpackChunkName: "pages/referral/index" */))
const _83119b60 = () => interopDefault(import('../pages/terms.vue' /* webpackChunkName: "pages/terms" */))
const _6b0ae01a = () => interopDefault(import('../pages/coins/_symbol.vue' /* webpackChunkName: "pages/coins/_symbol" */))
const _32f380c5 = () => interopDefault(import('../pages/news/_id.vue' /* webpackChunkName: "pages/news/_id" */))
const _1479741b = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/coins",
    component: _46920ce4,
    name: "coins___fa"
  }, {
    path: "/contact",
    component: _65851fae,
    name: "contact___fa"
  }, {
    path: "/fee",
    component: _06a85452,
    name: "fee___fa"
  }, {
    path: "/news",
    component: _73ff5b1d,
    name: "news___fa"
  }, {
    path: "/referral",
    component: _3f4147e7,
    name: "referral___fa"
  }, {
    path: "/terms",
    component: _83119b60,
    name: "terms___fa"
  }, {
    path: "/coins/:symbol",
    component: _6b0ae01a,
    name: "coins-symbol___fa"
  }, {
    path: "/news/:id",
    component: _32f380c5,
    name: "news-id___fa"
  }, {
    path: "/",
    component: _1479741b,
    name: "index___fa"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
